import { DemoExample } from "@/components/sections/DemoSection";

export const objectRemovalDemo: DemoExample = {
    label: "Object Removal",
    beforeImage: "/images/demos/homepage-demo/homepage-demo-before.webp",
    beforeImageSrcSet: "/images/demos/homepage-demo/homepage-demo-before-400w.webp 400w, /images/demos/homepage-demo/homepage-demo-before-800w.webp 800w, /images/demos/homepage-demo/homepage-demo-before-1200w.webp 1200w",
    afterImage: "/images/demos/homepage-demo/homepage-demo-after.webp",
    afterImageSrcSet: "/images/demos/homepage-demo/homepage-demo-after-400w.webp 400w, /images/demos/homepage-demo/homepage-demo-after-800w.webp 800w, /images/demos/homepage-demo/homepage-demo-after-1200w.webp 1200w",
    title: "Remove Objects & People from Streets",
    description: "Clean up street photos by removing traffic cones, background people, and other distractions.",
    alt: "Before and after removing traffic cones and people from street photo"
};

export const personRemovalDemo: DemoExample = {
    label: "Person Removal",
    beforeImage: "/images/demos/remove-person-blazer/remove-person-blazer-before.webp",
    beforeImageSrcSet: "/images/demos/remove-person-blazer/remove-person-blazer-before-400w.webp 400w, /images/demos/remove-person-blazer/remove-person-blazer-before-800w.webp 800w, /images/demos/remove-person-blazer/remove-person-blazer-before-1200w.webp 1200w",
    afterImage: "/images/demos/remove-person-blazer/remove-ex-partners-after.webp",
    title: "Remove Person in Background",
    description: "Delete unwanted people from your photos seamlessly.",
    alt: "Before and after removing a person wearing blazer from photo"
};

export const crowdRemovalDemo: DemoExample = {
    label: "Crowd Removal",
    beforeImage: "/images/demos/crowd-removal/crowd-removal-before.webp",
    afterImage: "/images/demos/crowd-removal/crowd-removal-after.webp",
    title: "Remove Crowds from Landmarks",
    description: "Clear tourists from famous locations for perfect travel photos.",
    alt: "Before and after removing tourists from landmark photo"
};

export const strangerRemovalDemo: DemoExample = {
    label: "Stranger Removal",
    beforeImage: "/images/demos/stranger-removal/stranger-removal-before.webp",
    afterImage: "/images/demos/stranger-removal/stranger-removal-after.webp",
    title: "Remove Photobombers",
    description: "Delete unwanted people who walked into your shot.",
    alt: "Before and after removing stranger from personal photo"
};
